/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type GettingStartedRovoServiceAgentSelfServiceSetupEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{}
>;

export const gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint: EntryPoint<
	GettingStartedRovoServiceAgentSelfServiceSetupEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GettingStartedRovoServiceAgentSelfServiceSetupEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-rovo-agent-self-service-setup-embedded-view", jiraSpaEntry: "async-servicedesk-rovo-agent-self-service-setup-embedded-view" */ '@jira/servicedesk__solution-composer-embeds/src/RovoAgentSelfServiceSetupEmbeddedView.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
